import { invert } from 'lodash';
import { EPersonalInformation, EProperty } from '@timeedit/types';

export const PropertyLabel: Record<EProperty, string> = {
  [EProperty.ABSTRACT]: 'Abstract',
  [EProperty.STANDARD]: 'Follow type',
  [EProperty.TEMPLATE_OBJECT]: 'Template object',
  [EProperty.VIRTUAL_ABSTRACT]: 'Virtual abstract',
  [EProperty.VIRTUAL_STANDARD]: 'Virtual follow type',
};

export const PropertyValue = invert(PropertyLabel) as Record<string, EProperty>;

export const PersonalDataLabel: Record<EPersonalInformation, string> = {
  [EPersonalInformation.NO]: 'No',
  [EPersonalInformation.YES]: 'Yes',
  [EPersonalInformation.STANDARD]: 'Not specified',
};

export const PersonalDataValue = invert(PersonalDataLabel) as Record<
  string,
  EPersonalInformation
>;
